import axios from 'axios'
import { useQuery } from 'react-query'

export const useLogs = () => {
  const endPoint = `${process.env.REACT_APP_CONTACT_CENTER_MICROSERVICE_URL}call-logs/?page=0&size=10000`

  return useQuery(['call-logs'], async () => {
    const response = await axios.get(endPoint)
    return response.data
  })
}
